import React from "react";
import BackgroundImg from "../../assets/images/Group_24.png"; // Import your background image

const SessionEnd = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <div
                className="bg-cover bg-center"
                style={{
                    backgroundImage: `url(${BackgroundImg})`,
                    height: "449px",
                    width: "665px",
                    padding: "20px"
                }}
            >
                <div className="p-8">
                    <h1 className="font-Roboto text-[#0FA968] text-[56px] text-center" style={{fontWeight: "600"}}>Your Session Ended</h1>
                    <p className="font-Roboto text-[#3A3A40] text-[26px] text-center">Thank You for choosing us...</p>
                </div>
            </div>
        </div>
    );
};

export default SessionEnd;
